import { Alert, Snackbar } from '@mui/material'
import axios from 'axios'
import React, { useReducer, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { HeaderListUser, TableListUser } from '~/src/components/molecules'
import { ProtectedPage } from '~/src/components/templates'
import { useAdmins, UseAdminsParams } from '~/src/hooks/useApi'
import { adminRepository } from '~/src/repositories'
import { LoadingNormal } from '../../organisms'
import { DeleteDialog } from './components/DeleteDialog'

enum ActionType {
  SET_OFFSET,
  SET_KEYWORD,
}

type Action = {
  type: ActionType
  payload: Partial<UseAdminsParams>
}

const reducer = (state: UseAdminsParams, action: Action): UseAdminsParams => {
  switch (action.type) {
    case ActionType.SET_OFFSET:
      return { ...state, offset: action.payload.offset }
    case ActionType.SET_KEYWORD:
      return { ...state, offset: 1, keyword: action.payload.keyword }
  }
}

const initState: UseAdminsParams = { limit: 20 }

export const UserList: React.FC = () => {
  const { t } = useTranslation()
  const [search, setSearch] = useState('')
  const [params, dispatch] = useReducer(reducer, initState)
  const { data, mutate } = useAdmins(params)
  const [id, setId] = useState(0)
  const [name, setName] = useState('')
  const [showDialog, setShowDialog] = useState(false)
  const [showSnackBar, setShowSnackBar] = useState(false)
  const [severity, setSeverity] = useState<'success' | 'error' | 'info' | 'warning'>('success')
  const [message, setMessage] = useState('')

  const handleSearchValue = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(event.currentTarget.value)
  }

  const onSearch = () => {
    console.log({ search })
    dispatch({ type: ActionType.SET_KEYWORD, payload: { keyword: search } })
  }

  const reset = () => {
    setId(0)
    setName('')
  }

  const handleClose = async (execute = false) => {
    setShowDialog(false)
    if (execute && id !== 0) {
      try {
        await adminRepository.delete(id)
        mutate()
        setSeverity('success')
        setMessage('Successfully deleted')
        setShowSnackBar(true)
      } catch (e) {
        if (axios.isAxiosError(e)) {
          setSeverity('error')
          setMessage(e.message)
          setShowSnackBar(true)
        }
      } finally {
        reset()
      }
    }
  }
  const deleteAdminUser = async (id: number, name: string) => {
    setId(id)
    setName(name)
    setShowDialog(true)
  }

  if (!data) {
    return <LoadingNormal />
  }

  return (
    <ProtectedPage pageTitle={t('user_list.user_list_title')}>
      <HeaderListUser
        searchValue={search}
        handleSearchValue={handleSearchValue}
        onSearch={onSearch}
        isLoading={false}
      />
      <TableListUser
        data={data.admins!.map((admin: any) => ({
          ...admin,
          userId: admin.loginId,
          userName: admin.name,
        }))}
        pagination={data.pagination!}
        onPageChange={(page) =>
          dispatch({ type: ActionType.SET_OFFSET, payload: { offset: page + 1 } })
        }
        onDelete={deleteAdminUser}
      />
      <DeleteDialog open={showDialog} name={name} handleClose={handleClose} />
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={showSnackBar}
        autoHideDuration={3000}
        onClose={() => setShowSnackBar(false)}
      >
        <Alert severity={severity}>{message}</Alert>
      </Snackbar>
    </ProtectedPage>
  )
}
